import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;

  @media (orientation: landscape) {
    flex-direction: column;
    margin-top: 16px;
    margin-left: 32px;
  }
`;

export const ButtonWrapper = styled.label`
  display: flex;
  flex-direction: row;
  width: auto;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #c4c4c4;
  cursor: pointer;

  svg {
    font-size: 24px;
  }
`;

export const ButtonLabel = styled.div`
  font-size: 14px;
  color: #666;
  text-align: center;
  padding-right: 24px;

  @media (orientation: landscape) {
    margin: 0 5px;
  }
`;

export const StyledButton = styled.button`
  padding: 0 8px;
  margin: 2px;
  width: 56px;
  height: 42px;
  box-shadow: none;
  background: #fff;
  position: relative;
  cursor: pointer;
  border: none;
  
  @media (orientation: landscape) {
    max-height: 20vh;
    max-width: 20vh;
  }
}
`;

export const StyledInputFileWrapper = styled.div`
  width: 56px;
  height: 46px;
  position: relative;

  input {
    border: none;
  }

  label {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    color: #747474;
    line-height: 1;
    cursor: pointer;
  }
`;

export const StyledInputFile = styled.input`
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  margin: 2px;

  &::file-selector-button {
    visibility: hidden;
  }
  &::before {
    content: '';
    background: #ffffff;
    display: inline-block;
    padding: 8px;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1.4px;
    line-height: 16px;
    height: 100%;
    width: 100%;
    outline: none;
    -webkit-user-select: none;
    cursor: pointer;
    text-align: center;
  }
  &:disabled {
    & ~ label svg {
      color: rgba(0, 0, 0, 0.26);
    }
  }
`;
